"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var checkForErrors = function checkForErrors(field) {
  if (field === undefined) {
    return false;
  }
  if ((0, _isArray2["default"])(field)) {
    for (var i; i < field.length; i++) {
      if (checkForErrors(field[i])) {
        return true;
      }
    }
  }
  if (!(0, _isObject2["default"])(field)) {
    console.warn('Field is not array or object');
    return false;
  }
  if (field.touched !== undefined) {
    return !!field.error;
  }
  var isError = false;
  (0, _forEach2["default"])(field, function (item) {
    if (!isError) {
      isError = checkForErrors(item);
    }
  });
  return isError;
};
var _default = exports["default"] = checkForErrors;